import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import '../style/common/LogoHeader.scss';
import { useSelector } from 'react-redux';
import RemoveIcon from '@mui/icons-material/Remove';
const LogoHeader = ({ setShowLogoHeader }) => {
    const store = useSelector((store) => store);
    const { user } = store;
    const { userDetails } = user;


    return (
        <Box className='logoHeader-page'>
            <Box className='image-section'>
                <img
                    src="/images/logo.png"
                    alt="logo"
                    style={{ width: '40px', height: '100%' }}
                />
                <Typography><span style={{ color: '#ee4f3b' }}>{userDetails?.AgentName || ''}</span></Typography>
                <Typography><span style={{ color: '#49be69' }}>{`(${userDetails?.AgentCode || ''})`}</span></Typography>
            </Box>
            {user.companyRole?.Marquee !== '' &&
                <Box className='marquee-box'>
                    <marquee loop={-1}>{'Dear Agent, Welcome to MavenTech Labs Private Limited Book Bus Ticket Agent Application'}</marquee>
                </Box>
            }
            <Box className='hidebtn'>
                <Button
                    startIcon={<RemoveIcon />}
                    onClick={() => {
                        localStorage.setItem('logoHeaderHide', false)
                        setShowLogoHeader(false)
                    }}
                >
                    Hide
                </Button>
            </Box>
        </Box>
    )
}

export default LogoHeader